import type {SummaryT} from '@freckle/school/ts/common/models/summary'
import {useQueryParamAsString, useQueryParamAsNum} from '@freckle/school/ts/hooks/use-params'
import type {IdentityProviderOrNoneT} from '@freckle/school/ts/manage-teachers/api-helpers/filters'
import {parseDefaultIdpsFromQueryParam} from '@freckle/school/ts/manage-teachers/api-helpers/filters'
import {TeacherTabContainer} from './teacher-tab'
import type {Props as StudentTabProps} from './teacher-tab'

type TeacherFilterTagT = 'teacher-filters'
const TEACHER_FILTER_TAG: TeacherFilterTagT = 'teacher-filters'

export type TeacherTabFilteringT = {
  tag: TeacherFilterTagT
  student?: {
    id: number
    name: string
  }
  course?: {
    id: number
    name: string
  }
  school?: {
    name: string
  }
  identityProviders: Array<IdentityProviderOrNoneT>
  role?: string
  studentGrade?: string
  name?: string
  email?: string
}

type Props = {
  summary: SummaryT
} & StudentTabProps

export default function TeacherTabHandler(props: Props) {
  const {tableParams, summary, ...rest} = props

  // Course filter
  const courseId = useQueryParamAsNum('courseId')
  const courseName = useQueryParamAsString('courseName')
  const course =
    courseId !== null && courseName !== null
      ? {course: {id: courseId, name: decodeURIComponent(courseName)}}
      : {}

  // Student filter
  const studentId = useQueryParamAsNum('studentId')
  const studentName = useQueryParamAsString('studentName')
  const student =
    studentId !== null && studentName !== null
      ? {student: {id: studentId, name: decodeURIComponent(studentName)}}
      : {}

  const schoolName = useQueryParamAsString('schoolName')
  const schoolNameObj = schoolName !== null ? {school: {name: schoolName}} : {}

  const role = useQueryParamAsString('role')
  const roleObj = role !== null ? {role} : {}

  const studentGrade = useQueryParamAsString('studentGrade')
  const studentGradeObj = studentGrade !== null && studentGrade !== '' ? {studentGrade} : {}

  const teacherName = useQueryParamAsString('teacherName')
  const teacherNameObj = teacherName !== null ? {name: teacherName} : {}

  const email = useQueryParamAsString('email')
  const emailObj = email !== null ? {email} : {}

  const identityProviders = parseDefaultIdpsFromQueryParam(
    useQueryParamAsString('identityProviders'),
    {
      tag: 'for-teacher',
      ...summary
    },
    {tag: 'summary'}
  )

  const tableParamsWithFilter = {
    ...tableParams,
    additionalFilters: {
      tag: TEACHER_FILTER_TAG,
      ...course,
      ...student,
      ...schoolNameObj,
      ...roleObj,
      ...studentGradeObj,
      ...teacherNameObj,
      ...emailObj,
      identityProviders
    }
  }
  return <TeacherTabContainer tableParams={tableParamsWithFilter} summary={summary} {...rest} />
}
